import spartaEventsUtility from "global/sparta-events-utility";
import spartaTransportUtility from "global/sparta-transport-utility";
import spartaStoreUtility from "global/sparta-store-utility";
import spartaGlobalFunctions from "global/sparta-global-functions-utility";
import _ from "vendor/lodash";
import Handlebars from "vendor/handlebars";
import hbs from "vendor/handlebars";
import dataHelpers from "helpers/helpers-data";
import helpersComparisons from "helpers/helpers-comparisons";
import helperComparisons from "helpers/helpers-comparisons";
import spartaHelpers from "helpers/helpers-sparta";






String.prototype.capitalizeFirstLetter = function () {
  let string = this.toLowerCase();
  return string.charAt(0).toUpperCase() + string.slice(1);
}

dataHelpers.register(Handlebars);

const EVENTS = {
  SPARTA_GLOBAL_READY: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
  SPARTA_SECONDARY_READY: 'SPARTA_SECONDARY_READY.spartaBootstrapUtility',
  SPARTA_WINDOW_SCROLL: 'SPARTA_WINDOW_SCROLL.spartaBootstrapUtility',
  RULE_QUEUESTART: 'RULE-QUEUESTART.spartaRulesUtility',
  RULE_QUEUECOMPLETE: 'RULE-QUEUECOMPLETE.spartaRulesUtility',
  RULE_ADDCOMPLETE: 'RULE-ADDCOMPLETE.spartaRulesUtility',
  RULE_REMOVECOMPLETE: 'RULE-REMOVECOMPLETE.spartaRulesUtility',
  RULE_SWAPCOMPLETE: 'RULE-SWAPCOMPLETE.spartaRulesUtility',
  RULE_COMPLETE: 'RULE-COMPLETE.spartaRulesUtility',
};


const transitionInMap = {
  fadeIn: 'sparta-animate-fade-in',
  noneIn: 'sparta-animate-none-in',
};


const transitionOutMap = {
  fadeOut: 'sparta-animate-fade-out',
  noneOut: 'sparta-animate-none-out',
};

class spartaRulesUtility {

  get EVENTS() {
    return EVENTS;
  }

  constructor() {
    this.modules = {};
    this.builtJcr = {};

    spartaEventsUtility.sub(this.EVENTS.SPARTA_GLOBAL_READY, () => {
      this.run();
    }, true);

    spartaEventsUtility.sub(this.EVENTS.SPARTA_SECONDARY_READY, () => {
      this.run();
    }, true);

    spartaEventsUtility.sub('moduleInstances-spartaStore', (result) => {
      this.modules = (result.args === undefined) ? result.data.data : result.args.data;
    }, true);

    spartaEventsUtility.sub('spartaBreakpointChange', this._resizeRules.bind(this));

    window.sparta = window.sparta || {}

    this.queue = [];
  }













  run(context = null) {
    let _context = context || spartaStoreUtility.getData("applicationContext");

    if (window.sparta.widgetRules && _context) {
      if (_context.name && window.sparta.widgetRules[_context.name]) {
        this.queue = window.sparta.widgetRules[_context.name][_context.version] || [];
      } else {
        this.queue = [];
      }
    } else {
      this.queue = window.sparta.spaRules || [];
    }

    let rules = [...this.queue];



    if (_context !== null) {
      if (window.sparta.widgetRules) {
        if (_context.name && window.sparta.widgetRules[_context.name]) {
          rules = window.sparta.widgetRules[_context.name][_context.version] || [];
        } else {
          rules = [];
        }
      } else {
        rules = window.sparta.spaRules || [];
      }
    } else {
      rules = window.sparta.spaRules || [];
    }

    spartaEventsUtility.pub(this.EVENTS.RULE_QUEUESTART);

    if (rules) {
      const rulePromises = [];
      rules.forEach((rule, index) => {
        const conditionsPassed = rule.condition.every(this._evalConditions.bind(this));

        if (conditionsPassed) {
          rulePromises.push(this[rule.action](rule));
        } else {
          return Promise.resolve();
        }
      });

      Promise.all(rulePromises).then(() => {
        spartaEventsUtility.pub(this.EVENTS.RULE_QUEUECOMPLETE);
      });
    } else {
      spartaEventsUtility.pub(this.EVENTS.RULE_QUEUECOMPLETE);
    }

    return true;
  }






  addModule(args = {}) {
    const el = document.querySelector(args.target);

    let moduleRenderPromise = new Promise((resolve, reject) => {
      resolve(this.swapContent(args));
    }).then(() => {
      spartaEventsUtility.pub(this.EVENTS.RULE_ADDCOMPLETE)
    });

    return moduleRenderPromise;
  }






  removeModule(args = {}) {
    this._hideModule(args.actionData.target, args.actionData);
    spartaEventsUtility.pub(this.EVENTS.RULE_REMOVECOMPLETE);
    return true;
  }






  swapContent(args = {}) {
    const { target } = args.actionData;


    var el = document.querySelector(target);

    let moduleRenderPromise = new Promise((resolve, reject) => {
      el.addEventListener('animationend', this._renderSwapModule.bind(this, args), false);
      el.addEventListener('webkitAnimationEnd', this._renderSwapModule.bind(this, args), false);
      this._hideModule(target, args.actionData)
      resolve();
    });

    spartaEventsUtility.pub(this.EVENTS.RULE_SWAPCOMPLETE);

    return moduleRenderPromise;
  }







  evaluateViewportCondition(key, values = []) {
    return values.some((item) => {
      let currentMQ = spartaStoreUtility.getData('currentMQ');
      if (currentMQ.viewport === item) {
        return true;
      }
    });
  }







  evaluateCookieCondition(cookie, values = []) {
    const cookieVal = spartaGlobalFunctions.spartaGetCookie(cookie);
    return values.some((item) => {
      if (cookieVal === item) {
        return true;
      }
    });
  }







  evaluateUrlparamCondition(param, values = []) {
    const paramVal = spartaGlobalFunctions.getUrlParam(param);
    return values.some((item) => {
      if (paramVal === item) {
        return true;
      }
    });
  }







  evaluateEventCondition(event, values = []) {
    return values.forEach((item) => {
      spartaEventsUtility.sub(item, this._customEventCallBack.bind(this));
    });

    return false;
  }






  evaluateAlwaysCondition() {
    return true;
  }













  _evalConditions(condition) {
    let evalCondition = `evaluate${condition.type.capitalizeFirstLetter()}Condition`;
    return this[evalCondition](condition.key, condition.values)
  }

  _customEventCallBack(args, data) {
    if (this.queue.length) {
      this.queue.forEach((item) => {
        item.condition.forEach((cond) => {
          if (cond.values.indexOf(args.event) !== -1) {
            this[item.action](item);
          };
        });
      });
    }
  }

  _resizeRules() {
    if (this.queue.length) {
      this.queue.forEach((item) => {
        if (item.type.toLowerCase() === 'viewport') {
          let evalCondition = `evaluate${item.type.capitalizeFirstLetter()}Condition`;
          if (this[evalCondition](item.condition.key, item.condition.values)) {
            this[item.action](item);
          }
        }
      });
      spartaEventsUtility.pub(this.EVENTS.RULE_QUEUECOMPLETE);

    }
  }






  _renderSwapModule(args = {}, e) {
    const { template, version, name } = args.actionData;
    let { transitionIn, transitionOut } = args.actionData;

    if (!transitionIn) transitionIn = 'fadeIn';
    if (!transitionOut) transitionOut = 'fadeOut';


    if (transitionOutMap[transitionOut] && transitionOutMap[e.animationName]) {
      new Promise((resolve, reject) => {
        let requireObj;
        let requirePath = `modules/${template}/${version}/js/templates`;

        let _context = spartaStoreUtility.getData("applicationContext");


        if (_context) {
          requireObj = window.sparta.require[_context.name][_context.version].require;

          if (window.sparta.minify && window.sparta.minify[_context.name] && window.sparta.minify[_context.name][_context.version]) {
            requirePath = `modules/${template}/${version}/js/templates.min`;
          }
        } else {
          requireObj = require;

          if (window.sparta.minify) {
            requirePath = `modules/${template}/${version}/js/templates.min`;
          }
        }

        requireObj([requirePath], (templates) => {
          resolve(templates);
        });
      }).then(templates => {
        helperComparisons.register(Handlebars);
        spartaHelpers.register(Handlebars);
        const hbTemplate = templates.default.get(name);
        const actionData = args.actionData;
        const datasources = actionData.data;
        const spaParams = spartaStoreUtility.getData("spaParams");
        this.builtJcr = {};

        this.builtJcr['module'] = actionData.moduleParams;
        this.builtJcr['page'] = spaParams.pageParams;
        this.builtJcr['site'] = spaParams.siteParams;
        this.builtJcr['global'] = spaParams.global;

        let ajaxCalls = [];

        Object.keys(datasources).forEach(function (key) {
          return ajaxCalls.push(new Promise((resolve) => {
            this._ruleAjaxRequest(key, datasources[key], resolve);
          }));
        }, this);

        Promise.all(ajaxCalls).then(() => {
          this._renderModule({
            template: hbTemplate,
            data: this.builtJcr,
            rule: args
          });
        });

      });
    }

    if (!transitionIn) transitionIn = 'fadeIn';
    if (!transitionOut) transitionOut = 'fadeOut';

    if (transitionInMap[transitionIn] && transitionInMap[e.animationName]) {
      const { template, version, name, target } = args.actionData;
      let el = document.querySelector(target),
        transitionInClassName = transitionInMap[transitionIn];

      if (el.classList)
        el.classList.remove(transitionInClassName);
      else
        el.className = el.className.replace(new RegExp('(^|\\b)' + transitionInClassName.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

  }


  _ruleAjaxRequest(key, data, resolve) {
    let ajaxUrl = this._setAjaxUrl(data.urlPath);

    let xhr = new XMLHttpRequest();

    let requestMethod = (data.hasOwnProperty('method')) ? data.method : "GET";
    let requestParams = (data.hasOwnProperty('params')) ? data.params : {};

    xhr.open(requestMethod, ajaxUrl);

    xhr.onload = function () {
      if (xhr.status === 200) {
        this.builtJcr[key] = JSON.parse(xhr.responseText);
        resolve();
      }
    }.bind(this);

    requestParams = this._parseObjectParams(requestParams);

    xhr.send(JSON.stringify(requestParams));

  }

  _setAjaxUrl(urlPath) {
    let path = (urlPath.indexOf('http') !== -1) ? urlPath : '/' + urlPath;


    if (path.substr(0,1) === '/') {
      let spaParams = spartaStoreUtility.getData("spaParams");

      if (spaParams && spaParams.siteParams && spaParams.siteParams.widgetAPIEndpoint) {
        path = spaParams.siteParams.widgetAPIEndpoint + path;
      }
    }


    var paramPattern = /(cookie\.\w+|store\.\w+|url\.\w+)/ig;
    var params = path.match(paramPattern);

    if (params !== null) {
      params.forEach((item) => {
        let replaceStr = '{' + item + '}';
        let pieces = item.split('.');

        if (pieces[0] === 'cookie') {
          path = path.replace(replaceStr, spartaGlobalFunctions.spartaGetCookie(pieces[1]));
        }
        if (pieces[0] === 'url') {
          path = path.replace(replaceStr, spartaGlobalFunctions.getUrlParam(pieces[1]));
        }
        if (pieces[0] === 'store') {
          let storePath = item.replace('store.', '');
          path = path.replace(replaceStr, spartaStoreUtility.getData(storePath));
        }
      });
    }
    return path;

  }

  _parseObjectParams(requestParams){

    let paramString = JSON.stringify(requestParams);
    var paramPattern = /(cookie\.\w+|store\.\w+|url\.\w+)/ig;
    var params = paramString.match(paramPattern);

    if(params !== null){
      params.forEach((item) => {
        let replaceStr = '{' + item + '}';
        let pieces = item.split('.');

        if (pieces[0] === 'cookie') {
          paramString = paramString.replace(replaceStr, spartaGlobalFunctions.spartaGetCookie(pieces[1]));
        }
        if (pieces[0] === 'url') {
          paramString = paramString.replace(replaceStr, spartaGlobalFunctions.getUrlParam(pieces[1]));
        }
        if (pieces[0] === 'store') {
          let storePath = item.replace('store.', '');
          paramString = paramString.replace(replaceStr, spartaStoreUtility.getData(storePath));
        }
      });
    }

    return JSON.parse(paramString);

  }






  _renderModule(options) {
    const { actionData } = options.rule;
    let newContent = {};
    let target;

    if (options.rule.actionData.target.charAt(0) !== '#') {
      target = '#' + actionData.target;
    } else {
      target = actionData.target;
    }

    let targetEl = document.querySelector(actionData.target);

    newContent.renderedModule = options.template(options.data);

    var moduleTemplate = Handlebars.compile(`{{{ renderedModule }}}`);

    var fullModule = moduleTemplate({
      module: actionData.moduleParams,
      renderedModule: newContent.renderedModule
    });

    targetEl.innerHTML = fullModule;
    const moduleJs = targetEl.getAttribute('data-init');

    this.modules[moduleJs][0].init();

    this._showModule(target,options.rule);
  }





  _hideModule(target, actionData) {
    if (target.charAt(0) !== '#') {
      target = '#' + target;
    }
    let { transitionIn, transitionOut } = actionData;

    if (!transitionIn) transitionIn = 'fadeIn';
    if (!transitionOut) transitionOut = 'fadeOut';

    let el = document.querySelector(target),
      transitionOutClassName = transitionOutMap[transitionOut],
      transitionInClassName = transitionInMap[transitionIn];


    if (el.classList)
      el.classList.remove(transitionInClassName);
    else
      el.className = el.className.replace(new RegExp('(^|\\b)' + transitionInClassName.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');


    if (el.classList)
      el.classList.add(transitionOutClassName);
    else
      el.className += ' ' + transitionOutClassName;

  }





  _showModule(target, rule) {
    if (target.charAt(0) !== '#') {
      target = '#' + target;
    }

    let { transitionIn, transitionOut } = rule.actionData;

    if (!transitionIn) transitionIn = 'fadeIn';
    if (!transitionOut) transitionOut = 'fadeOut';

    let el = document.querySelector(target),
      transitionOutClassName = transitionOutMap[transitionOut],
      transitionInClassName = transitionInMap[transitionIn];


    if (el.classList) {
      el.classList.remove(transitionOutClassName);
    }
    else {
      el.className = el.className.replace(new RegExp('(^|\\b)' + transitionOutClassName.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    if (el.classList){
      el.classList.add(transitionInClassName);
    }
    else {
      el.className += ' ' + transitionInClassName;
    }

    spartaEventsUtility.pub(this.EVENTS.RULE_COMPLETE, { ruleData: rule });


  }

}

export default new spartaRulesUtility();
